module.exports = __webpack_public_path__ + "static/media/rooms_having_type_x.fd4c0dac.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/rooms_having_type_x.csv
// module id = 699
// module chunks = 0